import React from 'react';
import styles from './show-help.module.css';

function ShowHelp() {
  const {container, helpContent, content1, content2} = styles;

  return (
    <>
      <div className={container}>
        <div className={helpContent}>
          <span>{`< Help >`}</span>
          <p className={content1}>
            Use the arrow keys or click on the blue arrow buttons for navigation
          </p>
        </div>
      </div>
    </>
  );
}

export default ShowHelp;
